/** Plan — no draft; guide Goal creation by checkup dimension code */
export const buildPlanNoDraftGoalQuestion = (dimensionCode: string): string => {
  const code = dimensionCode.trim();
  return `[goals/diagnosis_guide](referenceType=plan_guide)\ndimension code: ${code}.`;
};

/** Onboarding V3 plan-preview draft — plan_activation skill */
export const buildPlanActivationQuestion = ({
  draftGoalId,
  draftTitle,
}: {
  draftGoalId: string;
  draftTitle: string;
}): string => {
  const id = draftGoalId.trim();
  const title = draftTitle.trim();
  return `[goals/plan_activation](referenceType=plan_activation&referenceId=${id})\nHelp me continue creating my Goal "${title}"`;
};

/** Plan — resume draft Goal */
export const buildPlanResumeDraftGoalQuestion = ({
  draftGoalId,
  draftTitle,
  summary,
}: {
  draftGoalId: string;
  draftTitle: string;
  summary: string;
}): string => {
  const id = draftGoalId.trim();
  const title = draftTitle.trim();
  const summaryText = summary.trim();
  const sentence = `Help me continue creating my draft Goal "${title}" (id: ${id}): ${summaryText}`;
  const body = sentence.endsWith(".") ? sentence : `${sentence}.`;
  return `[goals/diagnosis_guide](referenceType=plan_guide_resume&referenceId=${id})\n${body}`;
};

/** Goal creator — with category direction */
export const buildGoalCreatorWithCategoryQuestion = (
  categoryName: string,
): string => {
  const category = categoryName.trim();
  return `/goal_creator Help me create a Goal focused on ${category}.`;
};

/** Goal creator — generic */
export const buildGoalCreatorQuestion = (): string =>
  "/goal_creator Help me create a Goal.";

/** Goal detail — Chat with Ed (review Goal) */
export const buildGoalReviewQuestion = ({
  goalId,
  goalTitle,
}: {
  goalId: string;
  goalTitle: string;
}): string => {
  const id = goalId.trim();
  const title = goalTitle.trim();
  return `[goals/goals_detail](referenceType=goal_review&referenceId=${id})\nI'd like to review my Goal: ${title}.`;
};

/**
 * Checkup completed card — Tell Ed what changed.
 * Reference-only; Ed sends the first message (autoSubmit: false on open).
 */
export const buildPlanCheckupChangedQuestion = ({
  goalId,
  title,
  summary,
}: {
  goalId: string;
  title: string;
  summary: string;
}): string => {
  const id = goalId.trim();
  const titleText = title.trim();
  const summaryText = summary.trim();
  const sentence = `Something changed since my "${titleText}" checkup (goal id: ${id}): ${summaryText}`;
  const body = sentence.endsWith(".") ? sentence : `${sentence}.`;
  return `[goals/diagnosis_guide](referenceType=plan_checkup_changed&referenceId=${id})\n${body}`;
};

/** Plan Checkup completed card — View report in Chat */
export const buildPlanCheckupViewReportQuestion = ({
  goalId,
  title,
}: {
  goalId: string;
  title: string;
}): string => {
  const id = goalId.trim();
  const titleText = title.trim();
  return `[goals/diagnosis_guide](referenceType=plan_checkup_report&referenceId=${id})\nShow me my checkup report for "${titleText}".`;
};
